// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"581e3299","977":"de57366e"}[chunkId] + ".chunk.js";
};